export default "__VITE_ASSET__DyD4Qd1A__"